// Tabs (Featured / Upcoming on the Events section, and any [data-wfc-tabs]).
// Animated gold underline follows the active tab. Keyboard arrow navigation.

export function initTabs(root = document) {
  const groups = root.querySelectorAll("[data-wfc-tabs]:not([data-tabs-bound])");

  groups.forEach((group) => {
    group.setAttribute("data-tabs-bound", "");
    const tabs   = Array.from(group.querySelectorAll("[data-tab]"));
    const panels = group.parentElement.querySelectorAll("[data-tab-panel]");
    if (!tabs.length) return;

    const activate = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", String(on));
        t.tabIndex = on ? 0 : -1;
      });
      const name = tab.getAttribute("data-tab");
      panels.forEach((p) => {
        p.hidden = p.getAttribute("data-tab-panel") !== name;
      });
    };

    tabs.forEach((tab, i) => {
      tab.setAttribute("role", "tab");
      tab.addEventListener("click", () => activate(tab));
      tab.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") activate(tabs[(i + 1) % tabs.length]);
        if (e.key === "ArrowLeft")  activate(tabs[(i - 1 + tabs.length) % tabs.length]);
      });
    });
  });
}
